import styles from "../../styles/common/LayoutAuthenticate.module.scss";

import React, {ReactNode} from 'react';
import Layout from "./Layout";
import clsx from "clsx";

interface LayoutProps {
  pageTitle: string;
  pageBodyClassName?: string;
  children: ReactNode,
}
function LayoutPublicPage({pageTitle, pageBodyClassName, children}: LayoutProps) {

  return (
    <Layout
      pageTitle={pageTitle}
      pageBodyClassName={clsx(styles.cPublicPage, "c-public-page", pageBodyClassName)}
      hideHeader
    >
      <section className="c-public-page-section-content">
        {children}
      </section>
    </Layout>
  );
}

export default LayoutPublicPage;